import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PedidoFilterModule } from '../../../pedido/filter';
import { PedidoPedidoListModule } from '../../../pedido/pedido/list';
import { PedidoExcelModule } from '../../../pedido/excel';

import { ClientePedidoComponent } from './cliente-pedido.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoFilterModule,
        PedidoPedidoListModule,
        PedidoExcelModule
    ],
    declarations: [
        ClientePedidoComponent
    ],
    exports: [
        ClientePedidoComponent
    ]
})
export class ClientePedidoModule { }
